<template>
    <div class="td-flex top-form td-form td-card rounded shadow">
        <div>
            <label class="td-label" for="holidays">Operation hours:</label>
            <div class="td-radio background ml-0">
                <label for="open-select-hours">
                    <input type="radio" v-model="model.type" id="open-select-hours" @change="updateHoursModel" :value="HoursOfOperationType.SelectHours" />
                    <span>Open Select Hours</span>
                </label>
                <label for="always-open">
                    <input type="radio" v-model="model.type" id="always-open" @change="updateHoursModel" :value="HoursOfOperationType.AlwaysOpen" />
                    <span>Always Open</span>
                </label>
                <label for="unknown" v-if="hoursTypeOriginal == HoursOfOperationType.Unknown">
                    <input type="radio" v-model="model.type" id="unknown" @change="updateHoursModel" :value="HoursOfOperationType.Unknown" />
                    <span>Unknown Hours</span>
                </label>
            </div>
        </div>
        <div>
            <label class="td-label" for="holidays">Operation hours on major holidays:</label>
            <select v-model="model.majorHolidaysCondition" class="td-select" id="holidays" @change="updateHoursModel">
                <option :value="HoursOfOperationHolidaysCondition.Closed">Closed</option>
                <option :value="HoursOfOperationHolidaysCondition.LimitedServices">Limited Services</option>
                <option :value="HoursOfOperationHolidaysCondition.RegularHours">Regular Hours</option>
            </select>
        </div>
    </div>
</template>

<script>
    import script from './HoursSettings';
    export default script;</script>
<style lang="less">
    @import "./HoursSettings";
</style>